import Button from '@material-ui/core/Button';
import React from 'react';
import config from '../../config';
import useCurrentUser from '../hooks/useCurrentUser';

export default function Header() {
  const { currentUser, logout } = useCurrentUser();

  return (
    <nav
      className={'navbar navbar-expand-lg navbar-light fixed-top'}
      style={{ backgroundColor: 'white' }}
      id="mainNav"
    >
      <div className="container">
        <a className="navbar-brand navbar-brand-basic" href="/">
          {config.siteTitle}
        </a>

        {currentUser && <Button onClick={logout}>Logout</Button>}
      </div>
    </nav>
  );
}
